import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { errorHandling } from "../../helper";

const contactUsSlice = createSlice({
  name: "contactUsSlice",
  initialState: {
    loading: false,
    contactUsList: [],
    contactUsDetails:{},
    cartDetails:{}
  },
  reducers: {
    loading: (state, action) => {
      state.loading = action.payload;
    },
    getContactUsList:(state,action)=>{
      state.contactUsList=action.payload
    },
    getContactDetailsFunc:(state,action)=>{
      state.contactUsDetails=action.payload
    }
  },
});

export const { loading, getContactUsList, getContactDetailsFunc } = contactUsSlice.actions;

export const getContactUsData = () => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_contact_us`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    dispatch(getContactUsList(data.data));
    dispatch(loading(false));
    // navigate("/");
  } catch (error) {
    toast.error(error?.response?.data?.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const getContactUsDetails = (id) => async (dispatch) => {
  try {
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/view_contact_us/${id}`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });

    dispatch(getContactDetailsFunc(data?.data));
  } catch (error) {
    toast.error(error?.response?.data?.error);
    errorHandling(error);
  }
};

export const updateForm = (id,fData) => async (dispatch) => {
  try {
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/update_contact_us_status/${id}`;
    const { data } = await axios.post(url, fData, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
  } catch (error) {
    toast.error(error?.response?.data?.error);
    errorHandling(error);
  }
};

export default contactUsSlice.reducer;
